const Colors = {
    Elmt: {
        Black: 0x000000,
        White: 0xFFFFFF,
        Blue: 0x1E22AA,
        DarkBlue: 0x1D1E3D,
        LightBlur: 0xF2F0E2,

    },
    Text: {
        Black: "#000000",
        White: "#FFFFFF",
        Blue: "#1E22AA",
        DarkBlue: "#1D1E3D",
        LightBlur: "#F2F0E2",

    }
}

export {
    Colors
}